import { render, staticRenderFns } from "./NewControl.vue?vue&type=template&id=859863b4&"
import script from "./NewControl.vue?vue&type=script&lang=js&"
export * from "./NewControl.vue?vue&type=script&lang=js&"
import style0 from "./NewControl.vue?vue&type=style&index=0&id=859863b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports